var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.visible && _vm.isPrintModeOn)?_c('div',{staticClass:"wci-textarea print-mode"},[_c('div',{staticClass:"hint"},[_vm._v(_vm._s(_vm.$attrs.label || ''))]),_c('span',[_vm._v(_vm._s(_vm.$attrs.value || ''))])]):(_vm.visible && !_vm.isPrintModeOn)?_c('VTextarea',_vm._g(_vm._b({class:[
      'wci-textarea',
      { 'conditional-field': _vm.conditionalField },
      { visible: _vm.visible },
    ],attrs:{"auto-grow":"","outline":typeof _vm.allBindings.outline !== 'undefined' ? _vm.allBindings.outline : true,"rows":"2"}},'VTextarea',_vm.allBindings,false),_vm.$listeners)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }